import React, { Component } from 'react';
import { connect } from 'react-redux';
import i18next from 'i18next';
import PropTypes from 'prop-types';
import { Icon, Button, Popup, Input, Form, Checkbox } from 'semantic-ui-react';

import '../DataGrid.scss';

class ChoicesFilter extends Component {

    render() {
        const { filter, filterChoices, onChange, ...rest } = this.props;

        return (
            <Popup
                trigger={
                    <Input fluid icon='list'
                        value={filter ?
                            i18next.t('chosenItems', { amount: Object.keys(filter.value.content).length })
                            :
                            i18next.t('choose')} />
                }
                on='click'
                position='bottom center'
                className='pi-data-grid-filter-component pi-data-grid-filter-choices'
                style={{ textAlign: i18next.dir() === 'rtl' ? 'right' : 'left' }}
            >
                <Form>
                    {filterChoices.map(filterOption => (
                        <Form.Checkbox key={filterOption.value}
                            label={filterOption.text}
                            value={filterOption.value}
                            checked={filter ? filter.value.content[filterOption.value] : false}
                            onChange={(event, data) => {
                                const chekboxes = filter ? filter.value.content : {};
                                chekboxes[data.value] = data.checked;

                                onChange({ multiChoice: true, content: chekboxes });
                            }}
                        />
                    ))}
                </Form>
            </Popup>
        );

    }
}

ChoicesFilter.propTypes = {
    filter: PropTypes.object,
    filterChoices: PropTypes.array.isRequired,
    onChange: PropTypes.func.isRequired,
};

export default connect(null)(ChoicesFilter);